import React from "react";
import { Typography, Box } from "@mui/material";
import QuestionAnswer from "./QuestionAnswer";
import TranslatedText from "./TranslatedText";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import chat from "../assets/images/chat.png";
import "../Styles/Activities.css";
import "../App.css";

const Activities = () => {
  return (
    <Box className="activ-box" component="main" sx={{ p: 3 }}>
      <Typography
        variant="h2"
        sx={{
          fontSize: 40,
          marginTop: 10,
          "@media screen and (max-width: 600px)": {
            fontSize: "28px",
            marginTop: "0",
          },
        }}
        gutterBottom
      >
        <TranslatedText defaultText="Наша діяльність" />
      </Typography>

      <div className="text-box1">
        <Typography
          variant="h3"
          sx={{
            fontSize: 25,
            fontWeight: 100,
            "@media screen and (max-width: 600px)": { fontSize: "18px" },
          }}
          gutterBottom
        >
          <TranslatedText defaultText="Ми працюємо, щоб допомогти українським біженцям успішно інтегруватися в норвезьке суспільство, надаючи їм інформаційну підтримку." />
        </Typography>
      </div>

      <div className="activ-container">
        <div class="activ-item-img">
          <h6 className="caption"> Photo by Anna Koberska </h6>{" "}
        </div>

        <div className="activ-item-text">
          <Typography
            className="activ-item-heading"
            variant="h3"
            sx={{
              fontSize: 32,
              fontWeight: 300,
              color: "#2875b0",
              padding: 3,
              "@media screen and (max-width: 600px)": {
                fontSize: "25px",
                textAlign: "center",
                padding: "0",
              },
            }}
          >
            <TranslatedText defaultText="Події та дозвілля" />
          </Typography>
          <ul className="activ-ul" sx={{ color: "#2875b0" }}>
            <li>
              <Typography
                variant="h5"
                fontSize={18}
                fontWeight={300}
                gutterBottom
              >
                <TranslatedText defaultText="Якщо ви хочете дізнатися, які заходи ми плануємо, натисніть " />
                <a
                  className="contact-a"
                  href="/calendar"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {<TranslatedText defaultText="ТУТ" />}
                </a>
              </Typography>
            </li>
            <br></br>
            <li>
              <Typography
                variant="h5"
                sx={{ fontSize: "18px", fontWeight: 300 }}
                gutterBottom
              >
                <TranslatedText defaultText="Якщо ви хочете дізнатися, які заходи відбуваються в муніципалітеті Ларвік, натисніть " />
                <a
                  className="contact-a"
                  href="https://aktiviteterilarvik.vilmer.no/3805"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {<TranslatedText defaultText="ТУТ" />}
                </a>
              </Typography>
            </li>
            <br></br>
            <li>
              <Typography
                variant="h5"
                fontSize={18}
                fontWeight={300}
                gutterBottom
              >
                <TranslatedText defaultText="Про діяльність у Vestfold og Telemark можна дізнатися " />

                <a
                  className="contact-a"
                  href="https://www.vtfk.no/skoler/holmestrand-vgs/kalender/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TranslatedText defaultText="ТУТ" />
                </a>
              </Typography>
            </li>
          </ul>
        </div>
      </div>

      <QuestionAnswer />
      <div className="contact-box">
        <div class="contact-img2">
          <img
            src={chat}
            alt=""
            style={{ width: "10vw", height: "", alignItems: "center" }}
          />
        </div>
        <Typography
          variant="h3"
          sx={{
            fontSize: 20,
            fontWeight: 380,
            "@media screen and (max-width: 600px)": { fontSize: "16px" },
          }}
          gutterBottom
        >
          <TranslatedText
            defaultText="Не знайшли відповіді на своє запитання?
            "
          />
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontSize: 20,
            fontWeight: 380,
            "@media screen and (max-width: 600px)": { fontSize: "16px" },
          }}
          gutterBottom
        >
          <TranslatedText
            defaultText="
             Зв'яжіться з нами."
          />
        </Typography>
        <div className="contact-link">
          <a
            className="contact-a"
            href="/contact"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {
              <h2
                className="box-link"
                style={{ fontSize: "20px", fontWeight: "400" }}
              >
                <TranslatedText defaultText="Перейдіть на сторінку контактів" />

                <ArrowForwardIcon />
              </h2>
            }
          </a>
        </div>
      </div>
    </Box>
  );
};

export default Activities;
